module.exports = __webpack_public_path__ + "static/media/logo-with-text.b0c5d9cb.png";